import { render, staticRenderFns } from "./IconLink.vue?vue&type=template&id=da69f170"
import script from "./IconLink.vue?vue&type=script&lang=js"
export * from "./IconLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports